import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { brand } from "../theme/brand";

/** Where a "create your account" link sits; shows up in Admin → Traffic. */
export type CtaPlacement =
  | "header"
  | "menu"
  | "banner"
  | "home"
  | "home_band"
  | "expiring"
  | "login"
  | "expired"
  | "signup"
  | "limit"
  | "locked"
  | "inspector"
  | "developers"
  | "guide";

let lastPath: string | null = null;

function send(body: Record<string, string>) {
  void fetch("/api/track", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
}

/** The first view carries the external referrer and `utm_source` (or `ref`); later views are in-app navigation. */
function trackView(path: string) {
  if (path === lastPath || path === "/admin" || path.startsWith("/admin/")) return;
  const first = lastPath === null;
  lastPath = path;
  const body: Record<string, string> = { kind: "view", path };
  if (first) {
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source") ?? params.get("ref");
    if (source) body.source = source;
    if (document.referrer) body.referrer = document.referrer;
  }
  send(body);
}

export function trackCta(target: CtaPlacement) {
  send({ kind: "cta", path: window.location.pathname, target });
}

/** Counts a page view on every route change (outside /admin). */
export function usePageViews() {
  const { pathname } = useLocation();
  useEffect(() => trackView(pathname), [pathname]);
}

/** accounts.passiolife.com link tagged with where it was clicked, plus click tracking. */
export function accountsLink(placement: CtaPlacement) {
  const href = `${brand.accountsUrl}/?${new URLSearchParams({ utm_source: "api-demo", utm_medium: "demo", utm_content: placement })}`;
  return { href, target: "_blank", rel: "noopener", onClick: () => trackCta(placement) } as const;
}
